<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:posting-rule-list">
                        <gofix-card fullContent class="mb-0">
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @new-item="openModalAdd"
                                @load-items="getTableData"
                                @row-click="editPostingEntry"
                                @import-items="importItems"
                                @delete-items="deleteItems"
                                ref="gofixTable">
                            </gofix-default-table>
                        </gofix-card>
                        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title="titleModal" hide-footer :centered="true" ref="modal-EditPrioritySet">
                            <b-form class="pb-20">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input label="Txn Code" v-model="posting_entry.txn_code"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <gofix-form-input label="Txn Description" v-model="posting_entry.txn_description"></gofix-form-input>
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-input label="Txn Account Type" v-model="posting_entry.txn_account_type"></gofix-form-input>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="Posting Type"
                                            vLabel="reference_value_text"
                                            :reduce="option => option.reference_value_text"
                                            v-model="posting_entry.posting_type"
                                            :options="OptionTransactionTypesName">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="GL Account DR (+)"
                                            vLabel="name"
                                            :reduce="option => option.name"
                                            v-model="posting_entry.debit"
                                            :options="OptionGLAccountDR">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="GL Account CR (-)"
                                            vLabel="name"
                                            :reduce="option => option.name"
                                            v-model="posting_entry.credit"
                                            :options="OptionGLAccountCR">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <gofix-form-dropdown
                                    label="Split TAX Amount from CR or DR Value"
                                    v-model="posting_entry.tax_on"
                                    :options="optionsTaxOn">
                                </gofix-form-dropdown>
                                <b-form-group label="Remarks" class="clear-both text-remark notFloat">
                                    <b-form-textarea v-model="posting_entry.remark" class="notFloat" rows="4"></b-form-textarea>
                                </b-form-group>
                            </b-form>
                            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.posting_rules, 'update')">
                                <gofix-button label="SUBMIT" @click="savePostingEntry" :loading="isAction" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                    </template>
                    <!-- <template slot="gofixTab:navision-file">
                        <navision-file></navision-file>
                    </template> -->
                    <!-- <template slot="gofixTab:transaction-types">
                        <transaction-type></transaction-type>
                    </template> -->
                    <template slot="gofixTab:gl-account-names">
                        <gl-account-name></gl-account-name>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from "vuex";
    const NavisionFile = () => import('./navision-file')
    const TransactionType = () => import('./transaction-type')
    const GLAccountNames = () => import('./gl-account-name')
    export default {
        name: 'posting-entries',
        components: {
            "navision-file" : NavisionFile,
            "transaction-type" : TransactionType,
            "gl-account-name" : GLAccountNames,
        },
        data() {
            return {
                tabData:[
                    {
                        key: "posting-rule-list",
                        title: "Posting Rules List",
                        active: true
                    },
                    // {
                    //     key: "navision-file",
                    //     title: "Navision File",
                    //     active: false
                    // },
                    // {
                    //     key: "transaction-types",
                    //     title: "Transaction Types",
                    //     active: false
                    // },
                    {
                        key: "gl-account-names",
                        title: "GL Account Names",
                        active: false
                    },
                ],
                tableConfig:{
                    name: 'posting-rules-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.chart_of_account, 'create'),
                        delete: this.$checkRole(this.$accessModule.chart_of_account, 'delete')
                    },
                    dataSelect:{
                        company_name:{
                            value: [],
                            value_field: 'name',
                            text_field: 'name'
                        }
                    },
                    filter: JSON.parse(JSON.stringify(filters['posting_entries'])),
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "txn_code",
                    sortDirection: "asc",
                },
                tableItems: [],
                isAction: false,
                OptionTransactionTypesName: [],
                optionsTaxOn: ['CR', 'DR'],
                posting_entry: {},
                titleModal: 'Create Posting Rules'
            }
        },
        computed: {
            ...mapGetters({
                GLAccountNameItems: "PostingEntryController/GLAccountNameItems",
                GLAccountNameInput: "PostingEntryController/GLAccountNameInput",
                NavisionFileItems: "PostingEntryController/NavisionFileItems",
                NavisionFileInput: "PostingEntryController/NavisionFileInput",
                TransactionTypesItems: "PostingEntryController/TransactionTypesItems",
                TransactionTypesInput: "PostingEntryController/TransactionTypesInput"
            }),
            OptionGLAccountCR(){
                return this.GLAccountNameInput.items.filter(x => {
                    return x.name !== this.posting_entry.debit
                })
            },
            OptionGLAccountDR(){
                return this.GLAccountNameInput.items.filter(x =>{
                    return x.name !== this.posting_entry.credit
                })
            }
        },
        created() {
            this.loadDataInput();
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("PostingEntryController/getPostingEntryItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the posting rules", "danger");
                        reject();
                    })
            },
            async deleteItems(callback) {
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PostingEntryController/deletePostingEntry", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'posting_rule'))
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            loadDataInput() {
                this.$store.dispatch('PostingEntryController/getGLAccountNamesItems', { page: 1, filter: { }, limit: 100, is_store: 1 })
                //this.$store.dispatch('PostingEntryController/getNavisionFileItems', { page: 1, filter: { }, limit: 100, is_store: 1 })
                this.$store.dispatch('PostingEntryController/getTransactionTypesItems', { page: 1, filter: { }, limit: 100, is_store: 1 })
                this.getRouteType()
            },
            savePostingEntry(){
                if(this.isAction) {
                    return;
                }
                this.isAction = true;
                if (!this.posting_entry.txn_code) {
                    this.isAction = false;
                    return this.$alertNotification("TXN Code is a required field.", "danger");
                }
                if (!this.posting_entry.posting_type) {
                    this.isAction = false;
                    return this.$alertNotification("Posting Type is a required field.", "danger");
                }

                if (!this.posting_entry.credit) {
                    this.isAction = false;
                    return this.$alertNotification("Credit GL Account is a required field.", "danger");
                }

                if (!this.posting_entry.debit) {
                    this.isAction = false;
                    return this.$alertNotification("Debit GL Account is a required field.", "danger");
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let keyMessage= 'adding'
                if(this.posting_entry && this.posting_entry.id) {
                    keyMessage = 'editing'
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('PostingEntryController/savePostingEntry', this.posting_entry)
                        .then(result => {
                            this.isAction = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$alertNotification(this.$notificationV2(keyMessage, 'posting_rule'));
                            this.$refs["modal-EditPrioritySet"].hide();
                        })
                        .catch(error => {
                            this.isAction = false;
                            if(error.response && error.response.data.error.message.error) {
                                return this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                        })
                }, 300)
            },
            async editPostingEntry(item){
                if(this.NavisionFileItems.total != this.NavisionFileInput.total || this.TransactionTypesItems.total != this.TransactionTypesInput.total || this.GLAccountNameItems.total != this.GLAccountNameInput.total) {
                    this.loadDataInput();
                }
                this.titleModal = 'Edit Posting Rules';
                this.posting_entry = Object.assign({}, item);
                this.$refs['modal-EditPrioritySet'].show();
            },
            openModalAdd (){
                if(this.NavisionFileItems.total != this.NavisionFileInput.total || this.TransactionTypesItems.total != this.TransactionTypesInput.total || this.GLAccountNameItems.total != this.GLAccountNameInput.total) {
                    this.loadDataInput();
                }
                this.titleModal = 'Create Posting Rules'
                this.posting_entry = {}
                this.$refs['modal-EditPrioritySet'].show()
            },
            /*Navision File*/
            getRouteType(){
                this.$store.dispatch("ReferenceController/getItems", {
                    limit:-1,
                    page:1,
                    filter: {
                        reference_type:"Navision File Type",
                    },
                }).then(response => {
                    this.OptionTransactionTypesName = response.items;
                });
            },
            //posting-entry
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`PostingEntryController/import`, {
                    fileImport: file
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'posting_rule');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
        }
    }
</script>
